import { lazy } from 'react';

export const AsyncPrivacyPageContainer = lazy(() => import(
  /* webpackChunkName: 'privacy_page' */
  './PrivacyPageContainer'
));
